import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import { parseBookingReference } from '@/entities/bookings'
import { BookingPage } from '@/pages/booking-page'

const BookingSearchSchema = z.object({
    partnerId: z.number().int().positive().optional().catch(undefined),
})

export const Route = createFileRoute('/_dashboard/branch/$branchId/booking/$id')({
    component: BookingPage,
    params: {
        parse: (params) => ({ id: parseBookingReference(params.id) }),
        stringify: (params) => ({ id: String(params.id) }),
    },
    validateSearch: BookingSearchSchema,
})
